/**
 * De Feed in tijdvakken: Nu · Vandaag · Eerder.
 *
 * Op tijd en niet op afstand, en dat is het verschil met het bord. Het bord
 * beantwoordt "wat komt er aan" — dan is afstand de as. De Feed beantwoordt
 * "wat gebeurt er", en dan is dat "wanneer".
 *
 * Woord voor woord dezelfde indeling als FeedBuckets.kt op Android, inclusief
 * de grens van twee uur. Twee apps die dezelfde lijst anders indelen, geven
 * twee antwoorden op dezelfde vraag.
 *
 * Los van het scherm omdat de grenzen de enige plek zijn waar dit fout kan gaan
 * zonder dat iemand het ziet: een bericht van vier uur oud onder "Nu" is niet
 * verkeerd genoeg om over te klagen en wel verkeerd genoeg om het scherm
 * onbetrouwbaar te maken.
 */

/** Onder dit aantal uur heet het "Nu". Twee uur is één rit. */
export const NOW_HOURS = 2;

export const BUCKETS = [
  { id: "nu", label: "Nu" },
  { id: "vandaag", label: "Vandaag" },
  { id: "eerder", label: "Eerder" },
];

const sameDay = (a, b) =>
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate();

export function bucketOf(at, now = new Date()) {
  if (!at) return "eerder";
  const when = new Date(at);
  if (Number.isNaN(when.getTime())) return "eerder";
  const hours = (now - when) / 3600000;
  // Vooruit in de tijd kan: een aankondiging die net binnenkwam heeft soms een
  // tijdstempel een minuut in de toekomst. Dat is "nu", niet "eerder".
  if (hours < NOW_HOURS) return "nu";
  return sameDay(when, now) ? "vandaag" : "eerder";
}

/**
 * De hele lijst, ingedeeld, in vaste volgorde, en zonder lege vakken.
 *
 * Een kop zonder iets eronder is een belofte die het scherm niet waarmaakt —
 * dezelfde regel die op het bord geldt voor elke knop met een getal erop.
 */
export function group(items, now = new Date()) {
  return BUCKETS.map(b => ({
    ...b,
    rows: (items || []).filter(i => bucketOf(i.at, now) === b.id),
  })).filter(b => b.rows.length > 0);
}
